import { HappyEmoji, SadEmoji } from "../common/icon";

/**
 * Renders optional extended copy below the consulting CTA (e.g. obesity flow).
 * Data shape: category.postCtaContent in category.json
 */
const ConsultingPostCtaContent = ({ content }) => {
  if (!content) return null;

  const {
    digitalProcess,
    includedBenefits,
    suitableAudience,
    lessSuitableAudience,
  } = content;

  return (
    <div className="consulting-post-cta" dir="rtl">
      {digitalProcess && (
        <section
          className="consulting-post-cta-block consulting-post-cta-block--align-center"
          aria-labelledby="consulting-post-cta-process-heading"
        >
          <div className="consulting-post-cta-block__head">
            <h2 id="consulting-post-cta-process-heading" className="consulting-post-cta-heading">
              {digitalProcess.heading}
            </h2>
            {digitalProcess.intro && (
              <p className="consulting-post-cta-intro">{digitalProcess.intro}</p>
            )}
          </div>
          <div className="consulting-post-cta-steps">
            {digitalProcess.steps?.map((step) => (
              <article key={step.stepOrder} className="consulting-post-cta-hw-box">
                <div className="consulting-post-cta-hw-box-grid">
                  <div className="consulting-post-cta-hw-box-left" aria-hidden="true">
                    <h6>{step.stepOrder}</h6>
                  </div>
                  <div className="consulting-post-cta-hw-box-right">
                    <h6>{step.title}</h6>
                    <p>{step.body}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      )}

      {includedBenefits && (
        <section
          className="consulting-post-cta-block consulting-post-cta-block--align-center"
          aria-labelledby="consulting-post-cta-benefits-heading"
        >
          <div className="consulting-post-cta-block__head">
            <h2 id="consulting-post-cta-benefits-heading" className="consulting-post-cta-heading">
              {includedBenefits.heading}
            </h2>
          </div>
          <div className="consulting-post-cta-benefits-grid">
            {includedBenefits.items?.map((item, i) => (
              <div key={i} className="consulting-post-cta-benefit-item">
                <h3 className="consulting-post-cta-benefit-title">{item.title}</h3>
                <p className="consulting-post-cta-benefit-desc">{item.description}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      {(suitableAudience || lessSuitableAudience) && (
        <section
          className="consulting-post-cta-audience-wrap"
          aria-label="למי זה מתאים ולמי פחות"
        >
          <div className="consulting-post-cta-audience-row">
            {suitableAudience && (
              <div className="consulting-post-cta-audience-slab consulting-post-cta-audience-slab--positive">
                <header className="consulting-post-cta-audience-slab__header">
                  <span
                    className="consulting-post-cta-audience-emoji consulting-post-cta-audience-emoji--happy"
                    role="img"
                    aria-label="מתאים"
                  >
                    <HappyEmoji />
                  </span>
                  <h2 className="consulting-post-cta-audience-slab__title">
                    {suitableAudience.heading}
                  </h2>
                </header>
                <ul className="consulting-post-cta-audience-bullets consulting-post-cta-audience-bullets--positive">
                  {suitableAudience.bulletPoints?.map((line, i) => (
                    <li key={i} className="consulting-post-cta-audience-bullets__row">
                      <span className="consulting-post-cta-audience-bullets__mark" aria-hidden>
                        &#10003;
                      </span>
                      <span className="consulting-post-cta-audience-bullets__text">{line}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {lessSuitableAudience && (
              <div className="consulting-post-cta-audience-slab consulting-post-cta-audience-slab--negative">
                <header className="consulting-post-cta-audience-slab__header">
                  <span
                    className="consulting-post-cta-audience-emoji consulting-post-cta-audience-emoji--sad"
                    role="img"
                    aria-label="פחות מתאים"
                  >
                    <SadEmoji />
                  </span>
                  <h2 className="consulting-post-cta-audience-slab__title">
                    {lessSuitableAudience.heading}
                  </h2>
                </header>
                <ul className="consulting-post-cta-audience-bullets consulting-post-cta-audience-bullets--negative">
                  {lessSuitableAudience.bulletPoints?.map((line, i) => (
                    <li key={i} className="consulting-post-cta-audience-bullets__row">
                      <span className="consulting-post-cta-audience-bullets__mark" aria-hidden>
                        &times;
                      </span>
                      <span className="consulting-post-cta-audience-bullets__text">{line}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </section>
      )}
    </div>
  );
};

export default ConsultingPostCtaContent;
